import { library } from "@fortawesome/fontawesome-svg-core";

// ********* Please add new icons alphabetically **********

import { faLinkedin, faTwitter } from "@fortawesome/free-brands-svg-icons";

import {
  faAddressCard,
  faAnglesDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowTurnUp,
  faArrowUp,
  faAsterisk,
  faBan,
  faBars,
  faCalendar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCheck,
  faCheckSquare,
  faCircleExclamation as faExclamationCircle,
  faCircleXmark,
  faClock,
  faClose,
  faCloudDownload,
  faDownload,
  faEdit,
  faEye,
  faFileAlt,
  faFlag,
  faGear,
  faGlobe,
  faGripVertical,
  faInfo,
  faInfoCircle,
  faKey,
  faLink,
  faLock,
  faPaperclip,
  faPencil,
  faPlay,
  faPlus,
  faRectangleXmark,
  faReply,
  faRetweet,
  faRightFromBracket,
  faRightLeft,
  faRotateLeft,
  faSave,
  faShareFromSquare,
  faSignOutAlt,
  faSliders,
  faSquare,
  faStickyNote,
  faTrash,
  faTriangleExclamation,
  faUnlock,
  faUpload,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faAddressCard,
  faAnglesDown,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowTurnUp,
  faArrowUp,
  faAsterisk,
  faBan,
  faBars,
  faCalendar,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCheck,
  faCheckSquare,
  faCircleXmark,
  faClock,
  faClose,
  faCloudDownload,
  faDownload,
  faEdit,
  faExclamationCircle,
  faEye,
  faFileAlt,
  faFlag,
  faGear,
  faGlobe,
  faGripVertical,
  faInfo,
  faInfoCircle,
  faKey,
  faLink,
  faLinkedin,
  faLock,
  faPaperclip,
  faPencil,
  faPlay,
  faPlus,
  faRectangleXmark,
  faReply,
  faRetweet,
  faRightFromBracket,
  faRightLeft,
  faRotateLeft,
  faSave,
  faShareFromSquare,
  faSignOutAlt,
  faSliders,
  faSquare,
  faStickyNote,
  faTrash,
  faTriangleExclamation,
  faTwitter,
  faUnlock,
  faUpload,
  faUser,
  faXmark,
);

/* add some free styles */

export default library;
